import { PeriodType } from '../../widget/date-range.widget.model';
export function getPeriodEndDate(periodType: PeriodType, date: Date): Date {
    const selectedDate = new Date(date.getTime());

    switch (periodType) {
        case PeriodType.WEEK:
            return getEndOfWeek(selectedDate);
        case PeriodType.MONTH:
            return getEndOfMonth(selectedDate);
        default:
            return selectedDate;
    }
}

function getEndOfWeek(date: Date): Date {
    const dayOfWeek = date.getDay();
    const daysUntilSaturday = 6 - dayOfWeek;
    date.setDate(date.getDate() + daysUntilSaturday);
    return date;
}

function getEndOfMonth(date: Date): Date {
    const nextMonth = date.getMonth() + 1;
    const firstDayNextMonth = new Date(date.getFullYear(), nextMonth, 1);
    firstDayNextMonth.setDate(firstDayNextMonth.getDate() - 1);
    return firstDayNextMonth;
}
